import React from "react";
import { useState } from "react";
import amazon from "../../../../../assets/icons/amazon.svg";
import appstore from "../../../../../assets/icons/appstore.svg";
import uber from "../../../../../assets/icons/uber.svg";
import starbucks from "../../../../../assets/icons/starbucks.svg";
import { Col, Form, Row } from "react-bootstrap";
import Button from "../../../../common/Button/Button";
import CardImg from "../../../../../assets/icons/CardImg.png";
import styles from "./FreezeCard.module.scss";
import { WarningNewIcon } from "../../../../../assets/icons/svgicons";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { cardDetailsAction, cardTranstionAction } from "../../../../../features/user/userSlice";
import { format } from "date-fns";


const FreezeCard = () => {
  const dispatch = useDispatch();
  const [cardtransaction, setTransactionData] = useState([]);
  const [cardDetails, setCardDetails] = useState([]);
  
  // const transactiondata = [
  //     { iconsrecent: amazon, name: "UPI-Amazon", dateCategory: "2024-01-15 • Shopping", amount: "$89.99", },
  //     { iconsrecent: starbucks, name: "Starbucks", dateCategory: "2024-01-15 • Shopping", amount: "$1,250", },
  //     { iconsrecent: uber, name: "Uber", dateCategory: "2024-01-15 • Shopping", amount: "$25.30", },
  //     { iconsrecent: appstore, name: "Apple Store", dateCategory: "2024-01-15 • Shopping", amount: "$199.00", },
  // ];

  const cardTranstionData = async () => {
    try {
      const res = await dispatch(cardTranstionAction());

      if (res.status === 200) {
        setTransactionData(res?.data?.data);
      }
    } catch (error) {
      console.log("Error");
    }
  };
 const cardDetailsData = async () => {
    try {
      const res = await dispatch(cardDetailsAction());
      if (res.status === 200) {
setCardDetails(res?.data?.data);      }
    } catch (error) {
      console.log("Error");
    }
  };
  
  useEffect(() => {
    cardTranstionData();
    cardDetailsData();
  }, []);

  return (
    <>
      <section className={styles.freezeCard}>
        <div className={styles.freezeCard_headebread}></div>
        <Row>
          <Col lg={8} md={8} className="cardColleft">
            <div className={styles.freezeCard_leftCard}>
              <div className={styles.freezeCard_leftCard_cardImg}>
                <img src={CardImg} alt="Card-Img" />
              </div>
              <div className={styles.freezeCard_leftCard_balanceInfo}>
                <h5>Available Balance</h5>
<h1 className="smallText">${cardDetails?.balance?.balance || 0}</h1>
                <div className={styles.cardSwitch}>
                  <div className={styles.cardSwitch_textSec}>
                    <h5>Card is Active</h5>
                    <p>Toggle to instantly freeze all transactions.</p>
                  </div>
                  <div className={styles.fieldswitch}>
                    <Form.Check type="switch" id="custom-switch" />
                  </div>
                </div>
                <Button fluid className={styles.common_btn}>
                  Unfreeze Card
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={4} md={4} className="cardColright">
            <div className={styles.freezeCard_rightAlert}>
              <h4>Security Alerts</h4>
              <div className={styles.alertBox}>
                <div className={styles.alertBox_icons}>
                  <WarningNewIcon />
                </div>
                <div className={styles.alertBox_textSec}>
                  <h5>Card is Active</h5>
                  <p>
                    A login from a new device was detected in London, I-JK. If
                    this was not you, please secure your account immediately.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div className={styles.recent_transactions}>
          <div className={styles.recent_transactions_head}>
            <h4>Recent transactions</h4>
            <Button variant="xtra_small" className={styles.common_btn}>
              View all
            </Button>
          </div>
          <ul>
            {cardtransaction?.map((transaction, index) => (
              <li key={index}>
                <div className={styles.recent_transactions_left}>
                  {/* <div className={styles.recent_icon}>
                                                 <img src={transaction.iconsrecent} alt="" />
                                               </div> */}
                  <div className={styles.textbox}>
                    <h6>{transaction.merchantName}</h6>
                    {/* <p>{transaction.createdAt}</p> */}
                    <p>
                      {transaction?.created_at &&
                      !isNaN(new Date(transaction.created_at).getTime())
                        ? format(
                            new Date(transaction.created_at),
                            "dd MMM, yyyy"
                          )
                        : "Invalid date"}
                      • {transaction.merchant_category}
                    </p>
                  </div>
                </div>
                <div className={styles.recent_transactions_right}>
                  <h4>${transaction.amount}</h4>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default FreezeCard;
